import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconEye = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3.16 12c2.498 4.13 5.453 6 8.84 6s6.342-1.87 8.84-6C18.342 7.87 15.387 6 12 6s-6.342 1.87-8.84 6m-2.028-.496C3.907 6.647 7.52 4 12 4s8.093 2.647 10.868 7.504a1 1 0 0 1 0 .992C20.093 17.353 16.48 20 12 20s-8.093-2.647-10.868-7.504a1 1 0 0 1 0-.992M12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
            clipRule="evenodd"
        />
    </svg>
);
